import styled from '@emotion/styled';
import Grid from '@material-ui/core/Grid/Grid';
import { createElement } from 'react';

import mq from '../../../styleUtility/mediaquery';
import DummyLatestInsightItem from '../DummyLatestInsightItem';

export const InsightCategoryListSkeleton = () => {
  return (
    <Grid container spacing={2}>
      {[...new Array(4)].map((_, i) => (
        <CardItem key={i} item md={4} sm={6} xs={12}>
          <DummyLatestInsightItem />
        </CardItem>
      ))}
    </Grid>
  );
};

const CardItem = styled(Grid)`
  ${mq('sp')} {
    min-height: 150px;
  }
`;
